@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.banners
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint

object DeleteBannerEndpoint : EndPoint<DeleteBannerEndpoint.Request, DeleteBannerEndpoint.Response>() {
    class Request(
        val id: KmmLong,
    )

    class Response
}